export const REFUND_CREDIT_CARD_STATE = 'refundCreditCard'

export const REFUND_CREDIT_CARD_REQUEST = 'REFUND_CREDIT_CARD_REQUEST'
export const REFUND_CREDIT_CARD_FAILURE = 'REFUND_CREDIT_CARD_FAILURE'
export const REFUND_CREDIT_CARD_SUCCESS = 'REFUND_CREDIT_CARD_SUCCESS'

export const STATUS_REFUND_CREDIT_CARD_OK = 'STATUS_REFUND_CREDIT_CARD_OK'
export const STATUS_REFUND_CREDIT_CARD_NOT_OK = 'STATUS_REFUND_CREDIT_CARD_NOT_OK'
